import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { OccDaysToArrivalService } from '../occ_days_to_arrival.service';
import { OccDaysToArrival } from '../occ_days_to_arrival';
import { OccDeviationService } from '../../occ-deviation';

@Component({
    selector: 'app-occDaysToArrivalComponent',
    templateUrl: './occ_days_to_arrival.component.html',
    styleUrls: ['./occ_days_to_arrival.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class OccDaysToArrivalComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private occDaysToArrivalComponentService: OccDaysToArrivalService,
		private occDeviationService: OccDeviationService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: UntypedFormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.occDaysToArrivalComponent = data.occDaysToArrivalComponent
	}

	@Input() occDaysToArrivalComponent: OccDaysToArrival;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	occDaysToArrivalId: number;

	// forms
	form1: UntypedFormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	occDeviationOptions: any[] = [];

	validationMessages = {
		'occDaysToArrivalId': [],
		days: [
			{ type: 'required', message: 'Days is required' }
		],
		pct: [
			{ type: 'required', message: 'Occupancy % is required' }
		],
		occDeviationId: [
			{ type: 'required', message: 'OccDeviation reference required' }
		]
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();
		this.loadOccDeviationList();

		// if we were passed the whole occDaysToArrivalComponent object
		if (this.occDaysToArrivalComponent) {
			this.occDaysToArrivalId = this.occDaysToArrivalComponent.occDaysToArrivalId;
			this.fixDates();
			this.form1.patchValue(this.occDaysToArrivalComponent);
		}
	}

	loadOccDeviationList()
	{
		try {
			this.occDeviationService.findAll()
				.subscribe(
					(res: any) => {
						this.occDeviationOptions = res.data.occDeviations;
						this.occDeviationOptions = res.data.occDeviations.map((dev: any) => ({
							...dev,
							label: `${dev.lowEndExpOccPCT}% to ${dev.highEndExpOccPCT}%`,
							value: dev.occDeviationId
						}));
					},
					(err: any) => {
						console.log('occMatrix-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.occDaysToArrivalId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.occDaysToArrivalComponentService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.occDaysToArrivalComponent = res.data.occDaysToArrivalComponent;
						this.doAdd.emit(this.occDaysToArrivalComponent);
					},
					(err: any) => {
						console.log('occDaysToArrivalComponent-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('occDaysToArrivalComponent: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.occDaysToArrivalComponentService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.occDaysToArrivalComponent = res.data.occDaysToArrivalComponent;
						this.doUpdate.emit(this.occDaysToArrivalComponent);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.occDaysToArrivalComponentService.delete(this.occDaysToArrivalComponent.occDaysToArrivalId)
				.subscribe(
					(res: any) => {
						console.log('occDaysToArrivalComponent-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.occDaysToArrivalComponent);
					},
					(err: any) => {
						console.log('occDaysToArrivalComponent-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			occDaysToArrivalId: [this.occDaysToArrivalId],
			occDeviationId: [null, Validators.required],
			days: [null, Validators.required],
			pct: [null, Validators.required],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.occDaysToArrivalComponent.occDaysToArrivalDate = moment(this.occDaysToArrivalComponent.occDaysToArrivalDate).toDate();
	}
}
